import {Book} from "./book.js";

export class Work {
    constructor(bookCount, chapterCount, name, chapterLabelSingular, chapterLabelPlural, books, loggedBy) {
        this.bookCount = bookCount;
        this.chapterCount = chapterCount;
        this.name = name;
        this.chapterLabelSingular = chapterLabelSingular;
        this.chapterLabelPlural = chapterLabelPlural;
        this.books = books;
        this.loggedBy = loggedBy;
    }

    static from_json(json) {
        const books = [];
        json.books.forEach(book => books.push(Book.from_json(book)));
        return new Work(json.bookCount, json.chapterCount, json.name, json.chapterLabelSingular, json.chapterLabelPlural, books, json.loggedBy);
    }

    get_book_count() {
        return this.bookCount;
    }

    get_chapter_count() {
        return this.chapterCount;
    }

    get_name() {
        return this.name;
    }

    get_chapter_label_singular() {
        return this.chapterLabelSingular;
    }

    get_chapter_label_plural() {
        return this.chapterLabelPlural;
    }

    get_books() {
        return this.books;
    }

    get_logged_by() {
        return this.loggedBy;
    }
}